/**
 * Pending Changes Indicator Component
 * Warns user about unsent changes before closing tab
 */

import React, { useEffect } from 'react';
import { Box, Alert, AlertTitle, Typography } from '@mui/material';
import { Upload as UploadIcon } from '@mui/icons-material';

export function PendingChangesIndicator({ pendingChanges, changeCount = 0 }) {
    // Prevent tab close if there are pending changes
    useEffect(() => {
        if (!pendingChanges) return;

        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = 'You have unsaved changes that haven\'t synced to the server yet. Are you sure you want to leave?';
            return e.returnValue;
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [pendingChanges]);

    if (!pendingChanges) {
        return null;
    }

    return (
        <Alert 
            severity="warning" 
            icon={<UploadIcon />}
            sx={{ mb: 2 }}
        >
            <AlertTitle>Pending Changes</AlertTitle>
            <Typography variant="body2">
                You have {changeCount > 0 ? `${changeCount} unsent changes` : 'unsent changes'} saved locally. 
                {' '}They will sync automatically when you're back online.
            </Typography>
        </Alert>
    );
}

export default PendingChangesIndicator;
